import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import { Box, useTheme, useMediaQuery } from '@mui/material';

const DashboardLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const theme = useTheme();
  const isMobile = useMediaQuery('(max-width: 1200px)');

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
      <Header />
      <Box sx={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
        {!isMobile && (
          <Sidebar open={sidebarOpen} setOpen={setSidebarOpen} />
        )}
        <Box sx={{ flex: 1, p: 2, overflowY: 'auto' }}>
          <Outlet />
        </Box>
      </Box>
      <Footer />
    </Box>
  );
};

export default DashboardLayout;
